// Hardcoded SEO auto-fill templates for the Add/Edit Medicine dialogs.
// These used to live in a per-language DB section ("Add Medicine
// Dialog" -> "Meta Keyword String" etc.), which meant a newly-added
// language silently got nothing (or, for Arabic, a mistranslation that
// dropped the {_genBrand} placeholders entirely) until someone manually
// translated that DB entry. Keeping the templates here instead means a
// language always has usable SEO text the moment it's added, with no DB
// dependency and no risk of the placeholder tokens getting translated
// away by mistake.
export const seoDefaultTemplates = {
  en: {
    metaKeyword: "{_genBrand}",
    metaTitle: "Buy {_genBrand} {_str} online- Generic {_gen} - {_company}",
    pageTitle: "Buy {_genBrand} {_str} online- Generic {_gen} - {_company}",
    metaDesc:
      "Buy Generic {_gen} prescription medicine for {_subCat}. {_genBrand} {_dosage} ask price online- medicineforworld@gmail.com. Bangladesh",
  },
  cn: {
    metaKeyword: "{_genBrand}",
    metaTitle: "在线购买 {_genBrand} {_str} - Generic {_gen} - {_company}",
    pageTitle: "在线购买 {_genBrand} {_str} - Generic {_gen} - {_company}",
    metaDesc:
      "为 {_subCat} 购买通用 {_gen} 处方药。 {_genBrand} {_dosage} 在线询价 - medicineforworld@gmail.com。Bangladesh",
  },
  es: {
    metaKeyword: "{_genBrand}",
    metaTitle:
      "Compre {_genBrand} {_str} en línea- Genérico {_gen} - {_company}",
    pageTitle:
      "Compre {_genBrand} {_str} en línea- Genérico {_gen} - {_company}",
    metaDesc:
      "Compre medicamento genérico recetado {_gen} para {_subCat}. Consulte el precio de {_genBrand} {_dosage} en línea- medicineforworld@gmail.com. Bangladesh",
  },
  ru: {
    metaKeyword: "{_genBrand}",
    metaTitle:
      "Купить {_genBrand} {_str} онлайн- Дженерик {_gen} - {_company}",
    pageTitle:
      "Купить {_genBrand} {_str} онлайн- Дженерик {_gen} - {_company}",
    metaDesc:
      "Купить рецептурный дженерик-препарат {_gen} для {_subCat}. Узнать цену {_genBrand} {_dosage} онлайн- medicineforworld@gmail.com. Бангладеш",
  },
  sa: {
    metaKeyword: "{_genBrand}",
    metaTitle:
      "اشترِ {_genBrand} {_str} عبر الإنترنت - دواء جنيس {_gen} - {_company}",
    pageTitle:
      "اشترِ {_genBrand} {_str} عبر الإنترنت - دواء جنيس {_gen} - {_company}",
    metaDesc:
      "اشترِ الدواء الجنيس الموصوف طبياً {_gen} لعلاج {_subCat}. استفسر عن سعر {_genBrand} {_dosage} عبر الإنترنت - medicineforworld@gmail.com. بنغلاديش",
  },
};

// Fills a template for the given language (falling back to English for
// any language not listed above) using the medicine's own current field
// values.
export const fillSeoTemplates = (langCode, defaultSeo) => {
  const template = seoDefaultTemplates[langCode] || seoDefaultTemplates.en;
  const fill = (value) =>
    (value || "")
      .replace("{_genBrand}", defaultSeo.genBrand)
      .replace("{_str}", defaultSeo.str)
      .replace("{_gen}", defaultSeo.gen)
      .replace("{_company}", defaultSeo.company)
      .replace("{_subCat}", defaultSeo.subCat)
      .replace("{_dosage}", defaultSeo.dosage);

  return {
    metaKeyword: fill(template.metaKeyword),
    metaTitle: fill(template.metaTitle),
    pageTitle: fill(template.pageTitle),
    metaDesc: fill(template.metaDesc),
  };
};
